import React from 'react';
import { useParams } from "react-router-dom";
import { Swiper, Image, AutoCenter, Footer } from 'antd-mobile'
import dayjs from 'dayjs';
import './index.scss';
import { createFromIconfontCN } from '@ant-design/icons';


const Atest03 = () => {
    const date = dayjs();
    const params = useParams()
    console.log(params)
    const MyIcon = createFromIconfontCN({
        scriptUrl: '//at.alicdn.com/t/c/font_5169486_apm3rxyzekh.js', // 在 iconfont.cn 上生成
    });

    return <>
        {/* http://d.ddspp.com:30123/v3/v3/1000_1777353244#sc*/}
        <Swiper autoplay>
            <Swiper.Item key={`topimgmr1`}><Image src='https://shengcong.sh3.ikuai7.com/ap_res/v3/1000_1777352812#sc' /></Swiper.Item>
        </Swiper>

        <div style={{
            width: '100%',
            height: '39px',
            background: '#02af6f',
            backgroundImage: 'linear-gradient(to right, #0958d9, #fff)',
            color: '#FFF',
            lineHeight: '39px',
            paddingLeft: '7px',
            fontSize: '24px',
        }}>

            防伪溯源信息33333
        </div>
        

        <AutoCenter style={{ marginTop: '20px', fontSize: '24px' }}>{params.bsm}</AutoCenter>
        <AutoCenter style={{ marginTop: '20px', fontSize: '98px' }}><MyIcon type="icon-zhengpin" className='iconclass'
               
               /></AutoCenter>
        
        <div className='fwnr'>
            您好，你所查询的是河南亨特彩铝科技有限公司出品的系列产品，品质保证，请放心使用！此防伪码已被查询{Math.floor(Math.random() * 90 + 1)}次，首次查询时间为：{date.format('YYYY-MM-DD HH:mm:ss')}；

        </div>



        <div style={{
            marginTop: '21px',
            width: '100%',
            height: '39px',
            background: '#02af6f',
            backgroundImage: 'linear-gradient(to right, #0958d9, #fff)',
            color: '#FFF',
            lineHeight: '39px',
            paddingLeft: '7px',
            fontSize: '24px',
        }}>

            产品信息
        </div>

        <Image src='https://shengcong.sh3.ikuai7.com/ap_res/v3/1000_1777353244#sc' />






        <Footer label='没有更多了：此页面仅为样式示例'></Footer>


    </>
}

export default Atest03;